import React, { useEffect } from "react";

const LinkedInWidget = () => {
  useEffect(() => {
    if (document.getElementById("linkedinInsight")) return;

    // LinkedIn Insight Tag
    window._linkedin_partner_id =
      import.meta.env.VITE_LINKEDIN_PARTNERID || "6862516";
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(window._linkedin_partner_id);

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "linkedinInsight";
    script.defer = true;
    script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";

    script.onload = () => {
    };

    document.body.appendChild(script);
  }, []);

  return (
    <div>
      <noscript>
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src="https://px.ads.linkedin.com/collect/?pid=6862516&fmt=gif"
        />
      </noscript>
    </div>
  );
};

export default LinkedInWidget;
